import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const BrunchIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <path
        d="M25.6667 43.6666C37.6328 43.6666 47.3333 33.9661 47.3333 21.9999C47.3333 10.0337 37.6328 0.333252 25.6667 0.333252C13.7005 0.333252 4 10.0337 4 21.9999C4 33.9661 13.7005 43.6666 25.6667 43.6666Z"
        fill="#E8F1FF"
      />
      <path
        d="M25.6669 37.5634C34.2623 37.5634 41.2302 30.5954 41.2302 22C41.2302 13.4046 34.2623 6.43665 25.6669 6.43665C17.0715 6.43665 10.1035 13.4046 10.1035 22C10.1035 30.5954 17.0715 37.5634 25.6669 37.5634Z"
        fill="#F7BA61"
      />
      <path
        d="M34.0814 2.02844C40.5278 5.78236 44.8613 12.7668 44.8613 20.7642C44.8613 32.7304 35.1608 42.4309 23.1946 42.4309C20.2101 42.4309 17.3666 41.8272 14.7793 40.7357C17.9783 42.5986 21.6973 43.6666 25.6661 43.6666C37.6323 43.6666 47.3328 33.9661 47.3328 21.9999C47.3328 13.0184 41.8676 5.31331 34.0814 2.02844Z"
        fill="#E2EBFA"
      />
      <path
        d="M20.5066 38.6035L20.5138 38.6013C21.9682 38.1526 23.5242 38.2004 24.9619 38.7002C27.5116 39.5865 30.5097 39.289 33.1033 37.3562C34.6138 36.2306 34.5666 35.6667 36.5619 33.6385C37.5388 32.6455 37.9984 31.2549 37.8057 29.8754C37.6498 28.7593 37.0853 27.7702 36.2591 27.072C35.6025 26.5172 35.0107 25.8916 34.4726 25.2212C32.3317 22.5536 28.6987 21.3145 25.2369 22.3827L21.2595 23.6099C18.8934 24.34 17.5673 26.8499 18.2974 29.2159C18.5528 30.0437 18.0888 30.9217 17.2611 31.1772C15.3767 31.7586 14.3204 33.7576 14.9019 35.642C15.6317 38.0074 18.141 39.3334 20.5066 38.6035Z"
        fill="#FFF2E2"
      />
      <path
        d="M23.2832 3.57469V19.0202C23.2832 19.4701 23.6479 19.8348 24.0977 19.8348H39.9467C40.6775 19.8348 41.0385 18.9469 40.5152 18.4369L24.6662 2.99139C24.1501 2.4884 23.2832 2.85411 23.2832 3.57469Z"
        fill="#D77F4A"
      />
      <path
        d="M25.9176 13.6999C25.7503 13.6999 25.5829 13.636 25.4552 13.5084C25.1998 13.2529 25.1998 12.839 25.4552 12.5835L27.8225 10.2162C28.0778 9.96097 28.4919 9.96097 28.7473 10.2162C29.0027 10.4717 29.0027 10.8856 28.7473 11.1411L26.3801 13.5084C26.2523 13.6361 26.085 13.6999 25.9176 13.6999Z"
        fill="#AC5E2E"
      />
      <path
        d="M28.0953 15.878C27.928 15.878 27.7606 15.8141 27.633 15.6865C27.3775 15.431 27.3775 15.0171 27.633 14.7616L30.0002 12.3943C30.2556 12.1391 30.6696 12.1391 30.925 12.3943C31.1805 12.6498 31.1805 13.0637 30.925 13.3192L28.5578 15.6865C28.4301 15.8141 28.2627 15.878 28.0953 15.878Z"
        fill="#AC5E2E"
      />
      <path
        d="M30.2731 18.0552C30.1058 18.0552 29.9383 17.9913 29.8107 17.8637C29.5553 17.6083 29.5553 17.1943 29.8107 16.9388L32.178 14.5716C32.4333 14.3163 32.8473 14.3163 33.1028 14.5716C33.3582 14.827 33.3582 15.241 33.1028 15.4965L30.7355 17.8637C30.6078 17.9914 30.4405 18.0552 30.2731 18.0552Z"
        fill="#AC5E2E"
      />
      <path
        d="M12.0671 29.9501C13.4609 30.199 14.7521 29.1412 14.8363 27.7279C14.9711 25.4674 15.6427 22.3477 16.7949 19.0151C17.9471 15.6826 19.3459 12.8142 20.6362 10.9533C21.4428 9.78979 21.0807 8.16031 19.8309 7.49516C19.722 7.43727 19.609 7.38784 19.4919 7.34738C16.7518 6.39997 12.7883 10.6709 10.6392 16.8868C8.49005 23.1027 8.96917 28.9096 11.7092 29.8569C11.8264 29.8975 11.9457 29.9285 12.0671 29.9501Z"
        fill="#D83131"
      />
      <path
        d="M27.7452 34.9931C30.0768 34.9931 31.967 33.103 31.967 30.7713C31.967 28.4397 30.0768 26.5496 27.7452 26.5496C25.4136 26.5496 23.5234 28.4397 23.5234 30.7713C23.5234 33.103 25.4136 34.9931 27.7452 34.9931Z"
        fill="#FEA613"
      />
      <path
        d="M37.8045 29.8752C37.6486 28.7591 37.0842 27.7699 36.258 27.0718C35.6014 26.517 35.0096 25.8914 34.4715 25.221C32.595 22.8829 29.5724 21.6425 26.5234 22.0908C28.6676 22.404 30.6365 23.5221 31.9999 25.221C32.538 25.8914 33.1298 26.517 33.7864 27.0718C34.6126 27.7699 35.1771 28.7592 35.333 29.8752C35.5257 31.2546 35.066 32.6453 34.0893 33.6382C32.0939 35.6665 32.1411 36.2304 30.6306 37.356C29.3328 38.3231 27.9338 38.8808 26.5404 39.0855C28.6956 39.4005 31.0281 38.9016 33.1022 37.356C34.6126 36.2304 34.5654 35.6665 36.5608 33.6382C37.5376 32.6454 37.9972 31.2547 37.8045 29.8752Z"
        fill="#FFEFD2"
      />
      <path
        d="M31.7782 29.5265C31.0917 27.3017 28.7341 26.0535 26.5089 26.7345C27.7999 27.1312 28.8784 28.1388 29.3067 29.5265C29.9942 31.7545 28.7453 34.1179 26.5174 34.8054C26.5142 34.8064 26.5109 34.8072 26.5078 34.8081C27.2894 35.0483 28.1487 35.0646 28.9889 34.8054C31.2168 34.118 32.4657 31.7545 31.7782 29.5265Z"
        fill="#FE9901"
      />
      <path
        d="M40.5152 18.4371L24.6662 2.99159C24.1501 2.48869 23.2832 2.85431 23.2832 3.5749V4.2932L37.7966 18.4371C38.3199 18.9471 37.9588 19.8351 37.2281 19.8351H39.9467C40.6775 19.8351 41.0386 18.9471 40.5152 18.4371Z"
        fill="#C86D36"
      />
      <path
        d="M19.83 7.49542C19.7212 7.43753 19.6082 7.38811 19.4911 7.34765C18.8826 7.13733 18.2139 7.18473 17.5181 7.45311C17.5473 7.46715 17.577 7.48019 17.6057 7.49542C18.8555 8.16057 19.2177 9.79006 18.411 10.9535C17.1208 12.8145 15.722 15.6829 14.5698 19.0154C13.4175 22.3479 12.746 25.4677 12.6112 27.7282C12.5598 28.5913 12.0577 29.3212 11.3574 29.7024C11.47 29.7632 11.5869 29.8152 11.7084 29.8572C11.8255 29.8977 11.945 29.9287 12.0663 29.9504C13.4601 30.1993 14.7514 29.1415 14.8356 27.7282C14.9703 25.4677 15.6419 22.3479 16.7941 19.0154C17.9464 15.6829 19.3452 12.8145 20.6354 10.9535C21.4421 9.79006 21.0799 8.16057 19.83 7.49542Z"
        fill="#CA2C2C"
      />
      <path
        d="M13.9588 18.0342C13.7741 18.5683 14.0574 19.1508 14.5914 19.3355L16.4719 19.9857C16.5753 19.6646 16.6831 19.3409 16.7958 19.0152C16.9084 18.6894 17.0234 18.3682 17.1405 18.0518L15.2601 17.4017C14.7261 17.217 14.1435 17.5002 13.9588 18.0342Z"
        fill="#A72B2B"
      />
      <path
        d="M13.2264 22.8512C13.0417 23.3853 13.325 23.9678 13.859 24.1525L15.2541 24.6348C15.3795 23.9934 15.5308 23.3216 15.7079 22.6267L14.5276 22.2186C13.9936 22.0339 13.4111 22.3172 13.2264 22.8512Z"
        fill="#A72B2B"
      />
      <path
        d="M19.0536 13.644L17.6585 13.1617C17.1245 12.977 16.5419 13.2603 16.3572 13.7943C16.1726 14.3284 16.4558 14.9109 16.9899 15.0956L18.1701 15.5037C18.4602 14.8477 18.756 14.226 19.0536 13.644Z"
        fill="#A72B2B"
      />
    </SvgIcon>
  );
};

export default BrunchIcon;
